module.exports = __webpack_public_path__ + "static/media/hireteam.57c4658d.png";